export default __webpack_public_path__ + "static/media/cp_geo_ls.04f822b0.svg";